import { NgClass } from '@angular/common';
import { Component, effect, OnInit } from '@angular/core';
import { IonTabBar, IonTabButton, IonTabs } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { CurrentPlatformService } from '@services/current-platform.service';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ProfilesService } from '@services/profiles.service';
import { CapacitorHttp } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

// import { StorageService } from '../../services/storage.servcie';

@Component({
  selector: 'app-global-navigation',
  templateUrl: 'global.navigation.html',
  standalone: true,
  imports: [IonTabs, IonTabButton, IonTabBar, NgClass, TranslateModule],
})
export class GlobalNavigationComponent implements OnInit {
  platformReady: boolean = false;
  currentPlatform: string = '';
  isPrime!: boolean;
  tabs = [
    { tab: 'home', label: 'home.home', icon: 'icon-home' },
    { tab: 'get-care', label: 'home.getCare', icon: 'icon-care' },
    { tab: 'location', label: 'home.locations', icon: 'icon-location' },
    { tab: 'account', label: 'home.account', icon: 'icon-user' },
  ];

  constructor(
    private readonly authService: AuthService,
    private readonly platform: CurrentPlatformService,
    private readonly httpClient: HttpClient,
    private readonly profileService: ProfilesService,
    // private readonly storageService: StorageService,
  ) {
    effect(() => {
      this.isPrime = this.authService.isPrime();
    });
  }

  async ngOnInit(): Promise<void> {
    this.platformReady = await this.platform.isPlatformReady();
    this.currentPlatform = this.platform.getCurrentPlatform();
    await Preferences.remove({ key: 'REDIRECT_LOCATION' });
  }

  async onTabChange(event: any): Promise<void> {
    if (event.tab === 'account') {
      this.profileService.updateForceFetch(true);
    }
    const tokenData = await this.authService.getTokenPayload();
    if (tokenData.subUser) {
      this.authService.setSwitchingState(true);
      try {
        let token = await this.authService.getToken();
        const res: any = (await firstValueFrom(
          this.httpClient.post(
            `${environment.ollaApiUrl}/api/supertokens/account/switch-account`,
            { patientId: tokenData.patientId },
            {
              headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${token}`,
                'X-TENANT-ID': environment.orgSlug,
              },
            },
          ),
        )) as HttpResponse<any>;
        if (res.status < 200 || res.status >= 300) throw new Error();

        token = await this.authService.getToken();
        const patientInfo = await CapacitorHttp.get({
          headers: {
            'content-type': 'application/json',
            'X-TENANT-ID': environment.orgSlug,
            Authorization: `Bearer ${token}`,
          },
          responseType: 'json',
          url: `${environment.ollaApiUrl}/api/patient/v1/patient/${tokenData.patientId}/info`,
        });
        if (patientInfo.status < 200 || patientInfo.status >= 300) throw new Error();

        this.authService.setPatientData({ ...res, ...patientInfo.data });
        this.authService.setPrime(patientInfo.data.metadata?.nl?.isPrime);
      } finally {
        this.authService.setSwitchingState(false);
      }
    }
  }
}
